import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ClientService} from '../auth/client.service';

export interface ProductQueryTestRequest {
  query: string;
  categories: string[];
  productFeedIds: string[];
  market: string;
  limit: number;
}

export interface ProductQueryTestResponse {
  query: string;
  categories: string[];
  productFeedIds: string[];
  market: string;
  limit: number;
  count: number;
  results: ProductQueryTestResult[];
}

export interface ProductQueryTestResult {
  rank: number;
  sku?: string | null;
  name?: string | null;
  title?: string | null;
  itemGroupId?: string | null;
  category?: string | null;
  productFeedId?: string | null;
  productFeedName?: string | null;
  market?: string | null;
  availability?: string | null;
  size?: string | null;
  color?: string | null;
  price?: string | null;
  salePrice?: string | null;
  url?: string | null;
  searchRelevance?: number | null;
  raw: Record<string, unknown>;
}

@Injectable({
  providedIn: 'root'
})
export class ProductQueryTestService {
  private readonly http = inject(HttpClient);
  private readonly clientService = inject(ClientService);

  testQuery(request: ProductQueryTestRequest): Observable<ProductQueryTestResponse> {
    const clientId = this.clientService.client?.id ?? '';
    return this.http.post<ProductQueryTestResponse>(
      `${environment.aiBaseServerUrl}${clientId}/data-feeds/query-test`,
      request
    );
  }
}
